export default {"src":"/_next/static/media/wordpress.b62bd19e.svg","height":2490,"width":2500,"blurWidth":0,"blurHeight":0};